import { GroundCommonContent } from "../../../../modules/content/components/GroundCommonContent/GroundCommonContent";
import { GroundSection } from "../../../../modules/content/components/GroundSection/GroundSection";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";

export const SimpleHeroBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: ISimpleHeroBlockProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  return (
    <GroundSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="border-y border-weathered-steel bg-charcoal-green-ink px-6 py-14 text-mineral-gray md:px-10 md:py-20 lg:px-14 lg:py-24">
        <GroundCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingAs="h1"
          headingClassName="max-w-[17ch] text-[clamp(1.875rem,9.25vw,5.5rem)] md:text-7xl lg:max-w-[15ch] lg:text-8xl"
          tone="dark"
        />
      </div>
    </GroundSection>
  );
};

SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
